<ng-template #eventRef let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Current and Upcoming Classes</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-6" *ngFor="let e of eventlist">
				<table class="educard">
				<tr><th style="width:80%" class="location">{{e.location_name}}</th><th style="text-align:right"><button tabindex="-1" mat-stroked-button (color)="'accent'" class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="addClass(e.code)">
					<small><i class="material-icons">settings</i></small>
				</button></th></tr>
				<tr><th colspan="2" class="classname">{{e.name}}</th></tr>
				<tr><th colspan="2" class="muted">{{e.code}}</th></tr>
				<tr><th style="width:80%" class="seats">Seats Remaining {{e.total_remaining}} / {{e.total_seats}}</th><th class="cost">${{e.discount | number: '1.2-2'}}</th></tr>
				<tr><td colspan="2">{{e.display_description}}</td></tr>
				<tr><th colspan="2" class="muted">{{e.display_start}} - {{e.display_end}}</th></tr>
				</table>
			</div>
		</div>
	</div>
</ng-template>
<div *ngIf="eventlist.length"><button mat-stroked-button color="primary" (click)="showEvents()">Education</button></div>
